import { createStore } from "vuex";
import auth from "./modules/auth";
import user from "./modules/user";
import materials from "./modules/materials";
import locations from "./modules/locations";
import comments from "./modules/comments";
import utils from "./modules/utils";
import getters from "@/store/getters";

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    user,
    materials,
    utils,
    locations,
    comments,
  },
  getters,
});
